var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnMisscallBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#005993",
    rx: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 3,
    x: 9,
    y: 9,
    fill: "#fff",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.706 15H10.5a1.5 1.5 0 0 0 0 3h6.375a5.52 5.52 0 0 1 2.83-3zM16.59 21H10.5a1.5 1.5 0 0 0 0 3h7.725a5.49 5.49 0 0 1-1.634-3zM26 20a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-4.571-1.714a.571.571 0 1 1 1.143 0v2.285a.572.572 0 0 1-1.143 0v-2.285zM22 22.57a.572.572 0 1 0 0-1.143.572.572 0 0 0 0 1.143z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnMisscallBlue);
export default __webpack_public_path__ + "static/media/btn_Misscall_blue.0edc8a1e15c7a0e9f468a8527a52b21a.svg";
export { ForwardRef as ReactComponent };